import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <rect x='2' y='9' width='2' height='6' rx='1' fill='currentColor' />
        <rect x='5' y='6' width='2' height='12' rx='1' fill='currentColor' />
        <rect x='8' y='4' width='2' height='16' rx='1' fill='currentColor' />
        <rect x='11' y='6' width='2' height='12' rx='1' fill='currentColor' />
        <rect x='14' y='7' width='2' height='9' rx='1' fill='currentColor' />
        <rect x='17' y='6' width='2' height='11' rx='1' fill='currentColor' />
        <rect x='20' y='10' width='2' height='4' rx='1' fill='currentColor' />
    </svg>
);

export const AudioIcon = styled(Icon)({});
